// Off canvas for Interpreter maint
import { Text, StyleSheet } from 'react-native'
import React, { useEffect, useState, useContext } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Dropdown from 'react-dropdown';
import { ThemeContext } from '../context/ThemeContext.js';

const WorkSayer = (props) => {
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const [rec, setTalkerRec] = useState(props.rec);
  const [showRec, setShowRec] = useState(props.show);
  const editClose = () => setShowRec(false);
  const [regions, setRegions] = useState();
  const [spoken, setSpoken] = useState();
  const btnNormal = "btn btn-sm btn-outline-info";

  // Defaults
  const taxis = [
    { name: 'Free', value: 0 },
    { name: 'Pay', value: 1 },
  ];
  const actives = [
    { name: 'Active', value: 10 },
    { name: 'Inactive', value: 0 },
  ];
  const rounders = [
    { name: '15 min', value: 15 },
    { name: '1 hour', value: 60 },
  ];
  const basemins = [
    { name: '1hr', value: 60 },
    { name: '2hr', value: 120 },
  ];

  function handleSpoken(ele) {
    var langs = spokenValue.split(',')
    const newlangs = langs.filter(a => a !== ele.id);
    // Check/uncheck
    if (ele.checked) {
      langs.push(ele.id);
    } else {
      langs = newlangs;
    }
    // console.log('handleSpoken', ele, ele.id, spokenValue, newlangs, langs.toString());
    setSpokenValue(langs.toString());
  }

  const talkerValid = (form) => {
    var inValids = [];
    var isValid = true;
    console.log('validate', perAppt, parseInt(perAppt) <= 0);
    if (parseInt(perAppt) <= 0) {
      inValids.push("Per Appt Rate must be greater than zero (0).\n");
      isValid = false;
    }
    if (isValid) {
      edit(form);
    } else {
      alert(inValids);
    }
    return isValid;
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    var isValid = talkerValid(form);
    if (perAppt) { setValidated(!isValid) };
    // console.log('form', form, isValid);
    event.preventDefault();
    event.stopPropagation();
    // if (form.checkValidity() === false) {
    // }
    // setValidated(true);
  };

  const [validated, setValidated] = useState('false');
  const [talkerName, setTalkerName] = useState(props.rec.sayername);
  const [talkerEMail, setTalkerEMail] = useState(props.rec.sayeremail);
  const [talkerPhone, setTalkerPhone] = useState(props.rec.sayerphone);
  const [talkerAddress, setTalkerAddress] = useState(props.rec.sayeraddress);
  const [activeValue, setActiveValue] = useState(parseInt(props.rec.sayeractive));
  const [radioValue, setRadioValue] = useState(parseInt(rec.sayerPerMile) > 0 ? 1 : 0);
  const [rounderValue, setRounderValue] = useState(props.rec.sayerCiel);
  const [spokenValue, setSpokenValue] = useState(props.rec.sayerspeaks);
  const [regionValue, setRegionValue] = useState(props.rec.sayerregion);
  const [baseValue, setBaseValue] = useState(props.rec.sayerMin);
  const [perAppt, setPerAppt] = useState(props.rec.sayerPerAppt);
  const [perNoShow, setNoShow] = useState(props.rec.sayerNoShow);

  const { colorScheme, setColorScheme, theme } = useContext(ThemeContext);
  const styles = createStyles(theme, colorScheme);

  // get data
  useEffect(() => {
    fetchRegions();
    fetchSpoken();
    console.log('Sayer Work', props, spoken, regions);
  }, []);

  const fetchTalker = () => {
    // Load the Interpreter
    setTalkerName(talkerName);
    setShowRec(false);
    setTalkerRec(null);
    setValidated(false);
    var fresh = {};
    // 
    fetch(`${apptsUrl}getSayer?sayer=${talkerName}`)
      .then(response => response.json())
      .then(data3 => {
        fresh = data3[0];
        console.log('fresh.sayerspeaks', fresh.sayerspeaks)
        setTalkerRec(fresh);
        setShowRec(true);
        setStat1('hidden');
      })
      .catch(error => console.error(error));
  }


  function edit(form) {
    // Read the form data
    var speaks = []
    form.lang.forEach((box) => {
      if (box.checked) {
        console.log("box", box.id);
        speaks.push(box.id);
      }
    });
    console.log('speaks', speaks, form.lang, form.lang[0], form.lang[0].checked)
    var fullURL = `${apptsUrl}updSayer?recid=${rec.recid}`;
    fullURL = fullURL + `&sayername=${talkerName}`;
    fullURL = fullURL + `&sayeremail=${talkerEMail}`;
    fullURL = fullURL + `&sayerphone=${talkerPhone}`;
    fullURL = fullURL + `&sayerspeaks=${speaks}`;
    fullURL = fullURL + `&sayeractive=${activeValue}`;
    fullURL = fullURL + `&sayerregion=${regionValue}`;
    fullURL = fullURL + `&sayeraddress=${encodeURIComponent(talkerAddress)}`;
    fullURL = fullURL + `&sayerMin=${baseValue}`;
    fullURL = fullURL + `&sayerCiel=${rounderValue}`;
    fullURL = fullURL + `&sayertaxi=${radioValue}`;
    fullURL = fullURL + `&sayerPerAppt=${perAppt}`;
    fullURL = fullURL + `&sayerPerMile=${form.sayerPerMile.value}`;
    fullURL = fullURL + `&sayerNoShow=${perNoShow}`;
    // fullURL = fullURL + `&sayerphone=${formData.get("sayerphone")}`;
    // console.log('Sayer fullURL', fullURL);
    fetch(fullURL)
      .then(response => response.json())
      .then(data => {
        console.log('Sayer upd', data);
        setShowRec(false);
      })
      .catch(error => console.error(error));
    // const sayerphone = formData.get("sayerphone");
    // alert(`You are OK, '${sayerphone}'`);
    // isok = true;
  }

  // dropdown values
  const fetchSpoken = () => {
    // Load the region select options
    // 
    fetch(`${apptsUrl}getSpoken`)
      .then(response => response.json())
      .then(data2 => {
        setSpoken(data2);
      })
      .catch(error => console.error(error));
  }

  const fetchRegions = () => {
    // Load the region select options
    // 
    fetch(`${apptsUrl}getRegions`)
      .then(response => response.json())
      .then(data2 => {
        setRegions(data2);
      })
      .catch(error => console.error(error));
  }


  return (
    <Offcanvas show={showRec} className="mt-2" data-bs-theme="dark" placement='end' style={{ width: '500px' }}>
      <Offcanvas.Header className="sidebarright">
        <Offcanvas.Title>&nbsp;
          <Text style={styles.nametext}>&nbsp;&nbsp;{rec.sayername}&nbsp;&nbsp;</Text></Offcanvas.Title>
        <button className="btn btn-sm btn-outline-warning" onClick={editClose}>Close</button>
      </Offcanvas.Header>
      <Offcanvas.Body style={styles.text}>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col key={"Name"} className="col-sm-12">
              <FloatingLabel label='Name:'>
                <Form.Control style={{ width: '100%' }} as="input"
                  id='sayername'
                  name='sayername'
                  placeholder="Name"
                  required
                  value={talkerName}
                  isInvalid={!talkerName}
                  onChange={(e) => setTalkerName(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row style={{ zIndex: 10 }}>
            <Col key={"lblActive"} className="col-sm-4 text-end" style={{ alignContent: 'center' }} >
              <Form.Label>Is Active?:</Form.Label>
            </Col>
            <Col key={"ActiveStatus"} className="col-sm-8">
              <ButtonGroup aria-label="Active">
                {actives.map((radio, idx) => (
                  <ToggleButton
                    key={`active-${idx}`}
                    id={`active-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-secondary' : 'outline-info'}
                    name="activeradio"
                    value={radio.value}
                    checked={activeValue === radio.value}
                    onChange={(e) => setActiveValue(parseInt(e.currentTarget.value))}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </Col>
          </Row>

          <Row>
            <Col key={"Mail"} className="col-sm-12">
              <FloatingLabel label='E-Mail:'>
                <Form.Control style={{ width: '100%' }} as="input"
                  id='sayeremail'
                  name='sayeremail'
                  placeholder="name@example.com"
                  required
                  value={talkerEMail}
                  isInvalid={!talkerEMail}
                  onChange={(e) => setTalkerEMail(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col key={"Phone"} className="col-sm-12">
              <FloatingLabel label='Phone:'>
                <Form.Control style={{ width: '100%' }} as="input"
                  id='sayerphone'
                  name='sayerphone'
                  placeholder="555 555 5555"
                  required
                  value={talkerPhone}
                  isInvalid={!talkerPhone}
                  onChange={(e) => setTalkerPhone(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row>
            <Col key={"Address"} className="col-sm-12">
              <FloatingLabel label='Address:'>
                <Form.Control style={{ width: '100%', height: '5em' }} as="textarea"
                  id='sayeraddress'
                  name='sayeraddress'
                  placeholder="Address [Street, City, State. ZIP]"
                  value={talkerAddress}
                  onChange={(e) => setTalkerAddress(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row>
            <Col key={"lblSpeaks"} className="col-sm-2 text-end" style={{ alignContent: 'center' }}>
              <Form.Label>Speaks:</Form.Label>
            </Col>
            <Col key={"Speaks"} className="col-sm-10 basicControl" style={{ zIndex: 1100, width: '78%' }}>
              {spoken && spoken.map((lang) => (
                <Form.Check // prettier-ignore
                  inline
                  key={`speaks-${lang.value}`}
                  type={'checkbox'}
                  id={`${lang.value}`}
                  name={'lang'}
                  label={`${lang.value}`}
                  onChange={(e) => handleSpoken(e.target)}
                />
              ))}
            </Col>
          </Row>
          <Row>
            <Col key={"lblRegion"} className="col-sm-2 text-end d-flex flex-column justify-content-end">
              <Form.Label>Region:</Form.Label>
            </Col>
            <Col key={"Region"} className="col-sm-10" style={{ zIndex: 1000 }}>
              {regions && <Dropdown options={regions}
                onChange={(sel) => { setRegionValue(sel.label) }}
                value={regionValue}
                placeholder="Select a Region"
              />}
            </Col>
          </Row>
          <hr></hr>
          <Row>
            <Col key={"Rate"} className="col-sm-3">
              <FloatingLabel label='$/Hr:'>
                <Form.Control
                  required
                  id='sayerPerAppt'
                  name='sayerPerAppt'
                  placeholder="($/appt)"
                  value={perAppt}
                  isInvalid={!(parseInt(perAppt) > 0)}
                  onClick={(e) => e.target.select()}
                  onChange={(e) => setPerAppt(e.target.value)}
                />
              </FloatingLabel>
            </Col>
            <Col key={"lblBase"} className="col-sm-3">
              <FloatingLabel label='$/Appt:'>
                <Form.Control
                  value={baseValue * perAppt / 60}
                  isInvalid={!(baseValue * perAppt / 60 > 0)}
                  readOnly
                />
              </FloatingLabel>
            </Col>
            <Col key={"Base"} className="col-sm-3">
              <ButtonGroup style={{ zIndex: 50 }}>
                {basemins.map((baseradio, idx) => (
                  <ToggleButton
                    key={`base-${idx}`}
                    id={`base-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-success' : 'outline-info'}
                    name="radiobase"
                    value={baseradio.value}
                    checked={baseValue === baseradio.value}
                    onChange={(e) => setBaseValue(parseInt(e.currentTarget.value))}
                  >
                    {baseradio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup><br></br>Base Hours
            </Col>
            <Col key={"NoShow"} className="col-sm-3">
              <FloatingLabel label='$/No Show:'>
                <Form.Control
                  id='sayerNoShow'
                  name='sayerNoShow'
                  placeholder="($)"
                  value={perNoShow}
                  valid={(parseInt(perNoShow) >= 0 ? 'true' : 'false')}
                  onChange={(e) => setNoShow(e.target.value)}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <hr></hr>
          <Row style={{ zIndex: 10 }}>
            <Col key={"lblRoundUp"} className="col-sm-4">
              <Form.Label>Duration Round Up (Billing Increment):</Form.Label>
            </Col>
            <Col key={"RoundUp"} className="col-sm-8">
              <ButtonGroup aria-label="RoundUp">
                {rounders.map((radio, idx) => (
                  <ToggleButton
                    key={`rounder-${idx}`}
                    id={`rounder-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-success' : 'outline-info'}
                    name="rounderradio"
                    value={radio.value}
                    checked={rounderValue === radio.value}
                    onChange={(e) => setRounderValue(parseInt(e.currentTarget.value))}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <hr></hr>
          <Row>
            <Col key={"lblPerMile"}  className="col-sm-4 text-end" style={{ alignContent: 'center' }}>
              <Form.Label>Pay Mileage: </Form.Label>
            </Col>
            <Col key={"PerMile"} className="col-sm-3">
              <FloatingLabel label='$/Mile:'>
                <Form.Control
                  id='sayerPerMile'
                  name='sayerPerMile'
                  defaultValue={rec.sayerPerMile}
                  placeholder="($/mi)"
                  onChange={(e) => setRadioValue(parseFloat(e.currentTarget.value) > 0 ? 1 : 0)}
                />
              </FloatingLabel>
            </Col>
            <Col key={"FreePay"} className="col-sm-5">
              <ButtonGroup>
                {taxis.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    id={`radio-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-warning' : 'outline-success'}
                    name="radio"
                    value={radio.value}
                    checked={radioValue === radio.value}
                    onChange={(e) => setRadioValue(parseInt(e.currentTarget.value))}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <br></br>
          <Button type="submit" className="btn btn-primary active">Save</Button>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default WorkSayer;

function createStyles(theme, colorScheme) {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: 'black',
      // backgroundColor: theme.background,
    },
    nametext: {
      color: 'gold',
      fontSize: '1.2em',
      textAlign: 'left',
    },

  })
}


